import React, { useMemo, useContext } from 'react';
import { useDropzone } from 'react-dropzone';
import { ContextUserProfile } from '../../../contexts/UserProfileContext';
import { Alert } from '@mui/material';

const activeStyle = {
    borderColor: '#2196f3',
};

const acceptStyle = {
    borderColor: '#00e676',
};

const rejectStyle = {
    borderColor: '#ff1744',
};
export default function ImageDropZone({
    maxSizeAllowed,
    maxSizeAllowedMB,
    uploadFiles,
    setErrorMessage,
    disabled = false,
    disabledMessage,
}) {
    const { translate } = useContext(ContextUserProfile);

    const { getInputProps, isDragActive, isDragAccept, isDragReject, open } =
        useDropzone({
            accept: 'image/jpeg, image/jpg, image/png',
            noClick: true,
            noKeyboard: true,
            onDrop: droppedFiles => {
                if (droppedFiles.length) {
                    const allowedFiles = droppedFiles.filter(
                        file => file.size < maxSizeAllowed
                    );
                    if (allowedFiles.length < droppedFiles.length) {
                        const notAllowedFiles = droppedFiles.filter(
                            file => file.size >= maxSizeAllowed
                        );

                        setErrorMessage(
                            notAllowedFiles
                                .map(
                                    file =>
                                        `[${file.name}] => ${translate(
                                            'error_max_size_allowed'
                                        )} ${maxSizeAllowedMB}MB`
                                )
                                .join(', ')
                        );
                    } else {
                        setErrorMessage('');
                    }

                    if (allowedFiles.length) {
                        uploadFiles(allowedFiles);
                    }
                }
            },
        });

    const style = useMemo(
        () => ({
            ...(isDragActive ? activeStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [isDragActive, isDragReject, isDragAccept]
    );

    return (
        <div
            className={`properties__image-dropzone ${
                disabled ? '--disabled' : ''
            }`}
            style={style}
        >
            {disabled ? (
                <Alert
                    severity='warning'
                    className='width100perc height100perc flex flex-center flex-align-center'
                >
                    <p>{translate(disabledMessage)}</p>
                </Alert>
            ) : (
                <button
                    type='button'
                    onClick={open}
                    className='description-img-drag_btn'
                >
                    <input {...getInputProps()} />
                    {translate('drag_pictures')}
                </button>
            )}
        </div>
    );
}
